import { animate, animateChild, group, query, style, transition, trigger } from '@angular/animations';

const navigations: { [fromState: string]: string[] } = {
  OrderList: ['OrderType', 'OrderDetail'],
  OrderType: ['ProductList', 'DeliveryLocation'],
  DeliveryLocation: ['ProductList'],
  ProductList: ['ProductListDetail'],
  ProductListDetail: ['ProductDetailBuilder'],
  ProductCategoryList: ['RestaurantCart'],
  RestaurantCart: ['Checkout', 'CheckoutDeliveryAddressCreate', 'CheckoutDeliveryTime'],
  CheckoutDeliveryAddressList: ['CheckoutDeliveryAddressCreate', 'CheckoutDeliveryTime'],
  CheckoutDeliveryAddressCreate: ['CheckoutDeliveryTime'],
  CheckoutDeliveryTime: ['CheckoutPaymentList'],
  CheckoutPaymentList: ['CheckoutPaymentCard', 'CheckoutSuccess'],
  CheckoutPaymentCard: ['CheckoutSuccess'],
  CheckoutSuccess: ['OrderList', 'OrderDetail'],
};

const leftToRightStates = Object.keys(navigations)
  .reduce<string[]>((states, fromState) => {
    return [...states, ...navigations[fromState].map((toState) => `${fromState} => ${toState}`)];
  }, [])
  .join(', ');

const rightToLeftStates = Object.keys(navigations)
  .reduce<string[]>((states, fromState) => {
    return [...states, ...navigations[fromState].map((toState) => `${toState} => ${fromState}`)];
  }, [])
  .join(', ');

export const slideInAnimation = trigger('routeAnimations', [
  transition(leftToRightStates, [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          right: 0,
          width: '100%',
        }),
      ],
      { optional: true },
    ),
    query(':enter', [style({ right: '-100%' })]),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [animate('200ms ease-out', style({ right: '100%' }))], { optional: true }),
      query(':enter', [animate('200ms ease-out', style({ right: '0%' }))]),
    ]),
    query(':enter', animateChild()),
  ]),
  transition(rightToLeftStates, [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
        }),
      ],
      { optional: true },
    ),
    query(':enter', [style({ left: '-100%' })]),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [animate('200ms ease-out', style({ left: '100%' }))], { optional: true }),
      query(':enter', [animate('200ms ease-out', style({ left: '0%' }))]),
    ]),
    query(':enter', animateChild()),
  ]),
]);
